import React, { useEffect, useState, useRef } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../provider/AuthProvider";
import "./LoginFast.scss";

// Variables d'environnement pour l'URL de l'API
const API_URL = process.env.REACT_APP_API_URL;

const LoginFast = () => {
  // Gestion du token d'authentification
  const { setToken, setTokenRefresh } = useAuth();

  const formLogin = useRef(); // Gère les élements du formulaire
  // Gestion du message d'erreur du formulaire
  const [messageError, setMessageError] = useState("");

  // Redirection vers une autre page
  const [redirectTo, setRedirectTo] = useState();

  // Création des JWTokens
  const handleLogin = (e) => {
    e.preventDefault(); // Empeche le rafraichissement de la page

    // Récuperation des éléments du formulaire pour la requête
    const formData = {
      username: formLogin.current[0].value,
      password: formLogin.current[1].value,
    };

    axios
      .post(`${API_URL}/auth/jwt/create/`, formData)
      .then((response) => {
        // Configuration des JWTokens
        setToken(response.data.access);
        setTokenRefresh(response.data.refresh);
        // Redirection vers la page d'accueil
        // TODO : choisir où rediriger
        setRedirectTo("/");
      })
      .catch((error) => {
        // Recuperation du message d'erreur
        const message = error.response.data;
        // Création du message d'erreur en fonction de l'erreur
        if (message.username) {
          setMessageError("Login : " + message.username[0]);
        } else if (message.password) {
          setMessageError("Password : " + message.password[0]);
        } else {
          setMessageError("Login ou Password invalide");
        }
      });
  };

  useEffect(() => {
    formLogin.current[0].focus();
  }, [formLogin]);

  // Redirection vers une autre page choisie
  if (redirectTo) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return (
    <>
      <div className="login-fast">
        <h1>Login</h1>
        <form ref={formLogin} onSubmit={(e) => handleLogin(e)}>
          {/* TODO : Remove the select */}
          <select name="login" id="login">
            <option value="Admin">Admin</option>
            <option value="Bob">Bob</option>
            <option value="David">David</option>
          </select>
          {/* TODO : Remove the default values */}
          {/* <input type="text" placeholder="login" defaultValue="Arthur" required /> */}
          <input
            type="password"
            placeholder="password"
            defaultValue="Miyavi123!"
            required
          />
          <button type="submit">Login</button>
        </form>
        {messageError && <span>{messageError}</span>}
      </div>
    </>
  );
};

export default LoginFast;
